import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { GET_PRODUCT_REQUEST } from 'redux/products/constants';

import { addWish } from './api';
import {
  ALLOCATION_WISH_REQUESTING,
  ADD_ALLOCATION_WISH_REQUEST
} from './constants';

export function* add(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: ALLOCATION_WISH_REQUESTING });
    const response = yield call(
      addWish,
      customerId(),
      action.allocationId,
      action.wish
    );
    yield put({ type: GET_PRODUCT_REQUEST, slug: action.slug });
    action.successFunction(response.data);
  } catch (error) {
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(ADD_ALLOCATION_WISH_REQUEST, add);
}

export default function* productSagas() {
  yield all([watchList()]);
}

const customerId = () => {
  if (!Cookies.get('customerToken')) {
    return null;
  }
  return jwtDecode(Cookies.get('customerToken')).sub;
};
